
import { useAppSelector } from '../..'
import { type IUserListResponse } from '../../../models/User'

export const getLoading = (): boolean => useAppSelector((state) => state.students.loading)
export const actionLoading = (): boolean => useAppSelector((state) => state.students.actionLoading)
export const getStudentsList = (): IUserListResponse => useAppSelector((state) => state.students.userList)
